<template>
  <div class="widgetFilterForm" :class="userStore.borderClass">
    <!-- {{ modalTheme }} -->

    <!-- <DxFilterBuilder :value="filterValue">
			<DxField data-field="Product_ID" data-type="number" caption="ID" />
			<DxField data-field="Product_Name" />
			<DxField data-field="Product_Cost" data-type="number" caption="Cost" format="currency" />
		</DxFilterBuilder> -->
    <div :class="userStore.filterClass">
      <!-- <h6>asd modalTheme: {{ modalTheme }}</h6> -->
      <b-form-group :class="modalTheme" label="Priority Filter:" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          :class="modalTheme"
          id="checkbox-group-1"
          v-model="selected"
          :options="workListStore.widgetPrimaryFilters?.priorityOptions"
          :aria-describedby="ariaDescribedby"
          name="flavour-1"
          switches
          size="sm"
          @change="update_checkboxes"
        ></b-form-checkbox-group>
      </b-form-group>
      <!-- <pre>Selected: <strong>{{ selected }}</strong></pre> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useStoreWorkList } from "@/stores/workListsStore";

const workListStore = useStoreWorkList();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const selected = ref([]); // Must be an array reference!
const myOptions = ref(null);

function update_checkboxes(e) {
  // console.log("       update_checkboxes");
  // console.log(e);
  // console.log("    COMMIT >> NEW   STR >> setWidgetPrimaryFilters");

  // this.$store.commit('setWidgetPrimaryFilters', this.selected)

  // console.log(" selected");
  // console.log(selected.value);
  workListStore.setWidgetPrimaryFilters(selected.value);

  // console.log("     		 COMMIT >> NEW															 STR >> filterPrimaryWidgetGrid"); //
  // this.$store.commit('filterPrimaryWidgetGrid', this.selected)
  workListStore.filterPrimaryWidgetGrid(selected);
}

onMounted(() => {
  // console.clear();
// console.log("onMounted() :       WID  PRIORITY FILTERs   PRIMARY  >>>>");
  // console.log(" 	. . . . .  WidgetPriorityFiltersPrimary 	create() ");
  // console.log("workListStore.widgetPrimaryFilters");
  // // console.log(workListStore.widgetPrimaryFilters.priorityOptions.length);
  // console.log(workListStore.widgetPrimaryFilters.priorityOptions);
  // // console.log('myOptions')
  // // console.log(myOptions?.value?.length)
});
</script>

<style scoped>
.widgetFilterForm {
  border: 2px solid #dcf1de;
  border-radius: 3px;
  padding-left: 10px;
  padding-right: 05px;
  margin-left: 0%;
  background-color: transparent;
  width: auto !important;
  font-weight: 700;
  font-size: 9pt;
  max-height: 51px;
  text-align: left; /* Align all contents to the left */
}

.widgetFilterForm .b-form-group,
.widgetFilterForm .b-form-checkbox-group {
  text-align: left !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  display: flex;
  flex-direction: column;
}

.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

.custom-select-sm {
  height: calc(0.875rem + 0.5rem + 3px);
}
</style>
